var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ConfinedSpaces50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.927,11H26v3.18c5.673,0.954,10,5.876,10,11.82c0,6.627-5.373,12-12,12s-12-5.373-12-12 c0-5.944,4.327-10.866,10-11.82V11h-8.927C9.361,14.111,7,18.775,7,24c0,9.389,7.611,17,17,17s17-7.611,17-17 C41,18.775,38.639,14.111,34.927,11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,21c1.103,0,2-0.897,2-2s-0.897-2-2-2s-2,0.897-2,2S22.897,21,24,21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28,28.5c0,0,0-2.117,0-2.5c0-2.209-1.791-4-4-4s-4,1.791-4,4c0,0.383,0,2.5,0,2.5 c0,0.639,0.401,1.18,0.963,1.397l-0.923,3.538c-0.174,0.668,0.226,1.351,0.894,1.525c0.667,0.173,1.351-0.227,1.525-0.895L23.52,30 h0.96l1.061,4.065C25.687,34.628,26.194,35,26.749,35c0.104,0,0.211-0.013,0.316-0.04c0.668-0.175,1.068-0.857,0.894-1.525 l-0.923-3.538C27.599,29.68,28,29.139,28,28.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ConfinedSpaces50);
export default __webpack_public_path__ + "static/media/icons8-confined-spaces-50.20cc7269e81ec27017c7c9202ea2c856.svg";
export { ForwardRef as ReactComponent };